import {StyleSheet} from 'react-native';

export default StyleSheet.create({
  headerView: {
    borderBottomWidth: 0,
  },
  contentView: {
    paddingLeft: 16,
    paddingRight: 16,
  },
});
